import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const JobCard = ({ job }) => {
  const statusConfig = {
    active: { color: 'text-success', bg: 'bg-success/10', label: 'Active' },
    paused: { color: 'text-warning', bg: 'bg-warning/10', label: 'Paused' },
    completed: { color: 'text-primary', bg: 'bg-primary/10', label: 'Completed' },
    cancelled: { color: 'text-error', bg: 'bg-error/10', label: 'Cancelled' }
  };

  const status = statusConfig?.[job?.status] || statusConfig?.active;

  return (
    <div className="bg-card rounded-md p-2.5 md:p-6 shadow-warm transition-smooth hover:shadow-warm-md">
      <div className="flex items-start gap-2 md:gap-4 mb-2 md:mb-4">
        <Image
          src={job?.image}
          alt={job?.imageAlt}
          className="w-10 h-10 md:w-16 md:h-16 rounded-md object-cover flex-shrink-0"
        />
        <div className="flex-1 min-w-0">
          <h3 className="font-heading font-semibold text-sm md:text-lg text-foreground mb-0.5 md:mb-1 line-clamp-1">
            {job?.title}
          </h3>
          <p className="text-xs md:text-base text-muted-foreground mb-1 md:mb-2 line-clamp-2">
            {job?.description}
          </p>
          <div className="flex flex-wrap items-center gap-1.5 md:gap-3">
            <span className={`px-1.5 py-0.5 md:px-2 md:py-1 rounded-full text-[10px] md:text-xs font-medium ${status?.bg} ${status?.color}`}>
              {status?.label}
            </span>
            <span className="flex items-center gap-0.5 md:gap-1 text-[10px] md:text-sm text-muted-foreground">
              <Icon name="MapPin" size={12} className="md:w-[14px] md:h-[14px]" />
              {job?.location}
            </span>
            <span className="flex items-center gap-0.5 md:gap-1 text-[10px] md:text-sm font-medium text-foreground">
              <Icon name="DollarSign" size={12} className="md:w-[14px] md:h-[14px]" />
              ₱{job?.budget?.toLocaleString()}
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between pt-2 md:pt-3 border-t border-border">
        <div className="flex items-center gap-3 md:gap-4">
          <span className="flex items-center gap-1 text-[10px] md:text-sm text-muted-foreground">
            <Icon name="Users" size={12} className="md:w-[14px] md:h-[14px]" />
            {job?.applicants} applicants
          </span>
          <span className="flex items-center gap-1 text-[10px] md:text-sm text-muted-foreground">
            <Icon name="Eye" size={12} className="md:w-[14px] md:h-[14px]" />
            {job?.views} views
          </span>
        </div>
        <button className="px-2 py-1.5 md:px-4 md:py-2 rounded-md bg-primary text-primary-foreground text-xs md:text-sm font-medium hover:opacity-90 transition-smooth">
          View Details
        </button>
      </div>
    </div>
  );
};

export default JobCard;